<template>
    <div class="makemodelstepone">
        <div class="topheader">
            <div class="topheaderleft">
                欢迎您---{{username}}
            </div>
            <div class="topheaderright">
               <div class="back" @click="Back">
                   <i class="el-icon-arrow-left"></i>
                   <span>返回</span>
               </div>
               <div class="outlogin" @click="OutLogin">
                    <i class="el-icon-switch-button"></i>
                    <span>退出</span>
               </div>
            </div>

        </div>


        <div class="content">
            <div class="steps">
                <ul>
                    <li class="active">
                        <div class="steptop">
                            <span class="line"></span>
                            <span class="stepsicon">1</span>
                            <span class="line"></span>
                        </div>
                        <div class="stepbottom">
                            添加模型基本信息

                        </div>
                        
                    </li>
                    <li>
                        <div class="steptop">
                            <span class="line"></span>
                            <span class="stepsicon">2</span>
                            <span class="line"></span>
                        </div>
                        <div class="stepbottom">
                            添加作物周期农事

                        </div>
                        
                    </li>
                    <li>
                        <div class="steptop">
                            <span class="line"></span>
                            <span class="stepsicon">3</span>
                            <span class="line"></span>
                        </div>
                        <div class="stepbottom">
                            预览模型

                        </div>
                        
                    </li>
                </ul>

            </div>

            <div class="addcontent">
                <div class="addtips">
                    <div class="tipscontent">
                        <span class="addtipsicon" :style="addtipsicon"></span>
                        <span>模型基础信息</span>
                    </div>
                   

                </div>

                <div class="mxfrom">
                    <el-form ref="addmxform" :model="addmxform" label-width="140px" class="addmxfrom" :rules="addmxrules" >
                    
                        <el-form-item label="作物名称">
                            <el-select v-model="addmxform.zwname" placeholder="请选择农事事项" prop="zwname">
                                <el-option :label="item.name" :value="item.name" v-for="(item, index) in zwlxArr" :key="index"></el-option>
                            </el-select>
                        </el-form-item>


                        <el-form-item label="品种名称" prop="pzname">
                            <el-input v-model="addmxform.pzname"></el-input>
                        </el-form-item>
                        <el-form-item label="模型名称" prop="mxname">
                            <el-input v-model="addmxform.mxname"></el-input>
                        </el-form-item>
                        <el-form-item label="预计收成(公斤/亩)">
                            <el-input v-model="addmxform.yjsc"></el-input>
                        </el-form-item>
                        <el-form-item label="生育周期(天)">
                            <el-input v-model="addmxform.syzq"></el-input>
                        </el-form-item>
                        <el-form-item label="品种来源" class="mxtextarea">
                            <el-input type="textarea" v-model="addmxform.pzly"></el-input>
                        </el-form-item>
                        <el-form-item label="适种区域" class="mxtextarea">
                            <el-input type="textarea" v-model="addmxform.szqy"></el-input>
                        </el-form-item>
                        <el-form-item label="抗性鉴定" class="mxtextarea">
                            <el-input type="textarea" v-model="addmxform.kxjd"></el-input>
                        </el-form-item>
                        <el-form-item label="栽培技术要点" class="mxtextarea">
                            <el-input type="textarea" v-model="addmxform.zpjsyd"></el-input>
                        </el-form-item>
                    </el-form>

                </div>



                <div class="addtips">
                    <div class="tipscontent">
                        <span class="addtipsicon" :style="addtipsicon"></span>
                        <span>作物周期时长</span>
                    </div>
                    <div class="adbtns">
                        <el-button type="success" class="addkh-btn" @click="AddZwVisible=true">新增周期</el-button>
                    </div>
                    
                    

                </div>



                <el-table :data="ZwListData" border style="width: 100%">
                    <el-table-column
                    label="序号"
                    align="center" >
                    <template slot-scope="scope"> 
                        <span>{{scope.$index+1}}</span>
                    </template>
                    </el-table-column>
                    <el-table-column
                    prop="zqMc"
                    label="生育阶段"
                    align="center">
                    </el-table-column>
                    <el-table-column
                    prop="zqDays"
                    label="周期时长"
                    align="center">
                    </el-table-column>
                    <el-table-column
                    prop="paiXu"
                    label="排序"
                    align="center"
                    :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column label="操作" align="center" >
                        <template slot-scope="scope"> 
                          <el-button
                          size="mini"
                          type="primary"
                          icon="el-icon-edit"
                          @click="EditMsg(scope.$index)" title="修改"></el-button>
                          <el-button
                          size="mini"
                          type="danger"
                          icon="el-icon-delete"
                          @click="DeleteMsg(scope.$index)" title="删除"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

        </div>


        <div class="nextbtns">
            <el-button type="primary" @click="NextStep('addmxform')" class="nextbtn">下一步</el-button>
        </div>
<!--添加作物周期弹出框-->
<el-dialog title="新增作物作业周期" :visible.sync="AddZwVisible" width="60%">
    <el-form :model="AddZwForm" :rules="addzwrules" ref="AddZwForm" label-width="140px" class="demo-ruleForm" :inline="true">
        <el-form-item label="生育阶段" prop="addzwsyjd">
            <el-input v-model="AddZwForm.addzwsyjd"></el-input>
        </el-form-item>
        <el-form-item label="周期时长" prop="addzwzqsc">
            <el-input v-model="AddZwForm.addzwzqsc"></el-input>
        </el-form-item>
        <el-form-item label="排序(升序)" prop="addzwpx">
            <el-input v-model="AddZwForm.addzwpx"></el-input>
        </el-form-item>
       
        
        
    </el-form>   
    <div class="syjdimg">
        <span class="syjdspan">生育阶段图片</span>
        <div class="addzwimgsContent" @click="AddZwImgVisible=true">
          <img :src="addzwimgurl" alt="" class="syjdimgtarget">
          <p>{{addzwimgname}}</p>
        </div>
        
    </div>

    <div class="addzwbtns">

        <el-button type="primary" @click="AddZwBtn('AddZwForm')">确定</el-button>
        <el-button @click="resetForm('AddZwForm')">重置</el-button>
    </div>
    
    
    
    
    </el-dialog>



    <!--修改作物周期弹出框-->
<el-dialog title="修改作物作业周期" :visible.sync="ResZwVisible" width="60%">
    <el-form :model="ResZwForm" :rules="reszwrules" ref="ResZwForm" label-width="140px" class="demo-ruleForm" :inline="true">
        <el-form-item label="生育阶段" prop="reszwsyjd">
            <el-input v-model="ResZwForm.reszwsyjd"></el-input>
        </el-form-item>
        <el-form-item label="周期时长" prop="reszwzqsc">
            <el-input v-model="ResZwForm.reszwzqsc"></el-input>
        </el-form-item>
        <el-form-item label="排序(升序)" prop="reszwpx">
            <el-input v-model="ResZwForm.reszwpx"></el-input>
        </el-form-item>
       
        
        
    </el-form>   
    <div class="syjdimg">
        <span class="syjdspan">生育阶段图片</span>
        <div class="addzwimgsContent" @click="AddZwImgVisible=true">
          <img :src="reszwimgurl" alt="" class="syjdimgtarget">
          <p>{{reszwimgname}}</p>
        </div>
        
    </div>

    <div class="addzwbtns">

        <el-button type="primary" @click="ResZwBtn('ResZwForm')">确定</el-button>
        <el-button @click="ResresetForm('ResZwForm')">重置</el-button>
    </div>
    
    
    
    
    </el-dialog>
    
    
    <!--添加作物周期弹出框-->
    <el-dialog title="生育阶段图片" :visible.sync="AddZwImgVisible" width="60%">
        <div class="zwimgs">
          <ul class="zwimgsul">
            <li  v-for="item in ZwImgArr" @click="SelectImg(item.img_url,item.img_name)">
              <img :src="requetImgUrl+item.img_url" alt="">
              <span class="zwimgs-span">{{item.img_name}}</span>
    
            </li>
          </ul>
    
            
    
        </div>
        
    </el-dialog>

    </div>
  </template>
  
  <script>
    import storage from '../../Storage/storage.js';
    export default {
      name: "Makemodelstepone",
      data() {
        return {
         username:'',
         userid:'',
         addtipsicon:{
            backgroundImage: "url(./static/images/addicon.png)",
         },
         zwlxArr:[],
         addmxform: {
           zwname: '',
           pzname:'',
           mxname:'',
           yjsc:'',
           syzq:'',
           pzly:'',
           szqy:'',
           kxjd:'',
           zpjsyd:'',
         },
         addmxrules:{
            zwname:[
              { required: true, message: '请输入作物名称', trigger: 'blur' },
            ],
            pzname:[
              { required: true, message: '请输入品种名称', trigger: 'blur' },
            ],
            mxname:[
              { required: true, message: '请输入模型名称', trigger: 'blur' },
            ],
         },






ZwListData: [],
//添加作物弹出框
AddZwVisible:false,
AddZwForm: {
addzwsyjd:'',
addzwzqsc:'',
addzwpx:'',  
},
addzwimg:'',
addzwimgurl:'./static/images/plus.png',
addzwimgname:'',
addZwlxArr:[],
addzwrules: {
    addzwsyjd:[
    { required: true, message: '请输入生育阶段', trigger: 'blur' },
    ],
    addzwzqsc:[
    { required: true, message: '请输入周期时长', trigger: 'blur' },
    ],
    addzwpx:[
    { required: true, message: '请输入排序', trigger: 'blur' },
    ], 
},




//修改作物弹出框
ResZwVisible:false,
resindex:'',
ResZwForm: {
    reszwsyjd:'',
    reszwzqsc:'',
    reszwpx:'',  
    },
    reszwimg:'',
    reszwimgurl:'./static/images/plus.png',
    reszwimgname:'',
    reszwrules: {
        reszwsyjd:[
          { required: true, message: '请输入生育阶段', trigger: 'blur' },
        ],
        reszwzqsc:[
          { required: true, message: '请输入周期时长', trigger: 'blur' },
        ],
        reszwpx:[
          { required: true, message: '请输入排序', trigger: 'blur' },
        ], 
    },





    AddZwImgVisible:false,
    ZwImgArr:[],
    requetImgUrl:'',
    upimgurl:'',
    myHeaders: {
                token: ""
            }, 
        }
      },
      methods: {
        Back(){
            this.$router.go(-1);
        },
        OutLogin(){
           storage.remove('token');
           storage.remove('userid');
           storage.remove('username');
           this.$router.push({
                    path: '/',
                    query: {
                    }
            }) 
        },
        AddZwBtn(formName){
            // console.log(this.AddZwForm.addzwsyjd+','+this.AddZwForm.addzwpx);
            this.AddZwVisible=false;


            this.$refs[formName].validate((valid) => {
            if (valid) {
                this.ZwListData.push({         
                    zqMc:this.AddZwForm.addzwsyjd,
                    paiXu:this.AddZwForm.addzwpx,
                    zqDays:this.AddZwForm.addzwzqsc,
                    zqImage:this.addzwimg
               })

                this.AddZwForm.addzwsyjd='';
                this.AddZwForm.addzwpx='';
                this.AddZwForm.addzwzqsc=''
            } else {
              return false;
            }
          });

        },


        ResZwBtn(formName){
            this.ResZwVisible=false;
            this.$refs[formName].validate((valid) => {
            if (valid) {
                this.$set(this.ZwListData, this.resindex,  
                        {         
                        zqMc:this.ResZwForm.reszwsyjd,
                        paiXu:this.ResZwForm.reszwpx,
                        zqDays:this.ResZwForm.reszwzqsc,
                        zqImage:this.addzwimg
                        }
                )
            } else {
            return false;
            }
            });

        },
        EditMsg(index){
            this.ResZwVisible=true;
            this.resindex=index;
            this.ResZwForm.reszwsyjd=this.ZwListData[index].zqMc;
            this.ResZwForm.reszwpx=this.ZwListData[index].paiXu;
            this.ResZwForm.reszwzqsc=this.ZwListData[index].zqDays;

        },
        DeleteMsg(index){
            this.ZwListData.splice(index,1);
        },
        NextStep(formName){
            this.$refs[formName].validate((valid) => {
            if (valid) {
                // console.log(this.addmxform.zwname+','+this.addmxform.pzname+','+this.addmxform.mxname+','+this.addmxform.yjsc+','+this.addmxform.syzq+','+this.addmxform.pzly+','+
                // this.addmxform.szqy+','+this.addmxform.kxjd+','+this.addmxform.zpjsyd
                // );
                // console.log(this.ZwListData);



                var Addmodel=this.GLOBAL.Addmodel;
                this.$http.post(Addmodel,{userID:this.userid,zwName:this.addmxform.zwname,pzName:this.addmxform.pzname,modeName:this.addmxform.mxname,
                    yjsc:this.addmxform.yjsc,syZq:this.addmxform.syzq,pzLaiyuan:this.addmxform.pzly,szQuyu:this.addmxform.szqy,kxJd:this.addmxform.kxjd,
                    zpYd:this.addmxform.zpjsyd,zqlist:this.ZwListData
                },{'headers': {'Content-Type': 'application/json','token':this.myHeaders.token}},{emulateJSON:true}).then(function(res){
                    //   console.log(res); 
                      if(res.body.msg=='success'){
                        this.$router.push({
                            path: 'makemodelsteptwo',
                            query: {
                                modenum:res.body.modenum
                            }
                        }) 

                      }
                                         
                },function(err){})


            } else {
              return false;
            }
          });
          

            
        },
        SelectImg(image,name){
            this.addzwimgurl=this.requetImgUrl+image;
            this.addzwimg=image;
            this.addzwimgname=name;
            this.AddZwImgVisible=false;
          },

        GetImgList(){

            var Getimglist=this.GLOBAL.Getimglist;
                this.$http.post(Getimglist,{},{'headers': {'Content-Type': 'application/json','token':this.myHeaders.token}},{emulateJSON:true}).then(function(res){
                    //   console.log(res); 
                      if(res.body.code==0){
                          this.ZwImgArr=res.body.list;


                      }
                                         
                },function(err){})

            
        },
        GetZwList(){

var Zwlxlist=this.GLOBAL.Zwlxlist;
    this.$http.post(Zwlxlist,{},{'headers': {'Content-Type': 'application/json','token':this.myHeaders.token}},{emulateJSON:true}).then(function(res){
        //   console.log(res); 
          if(res.body.code==0){
              this.zwlxArr=res.body.list;
          }
                             
    },function(err){})


}
        
        
      },
      mounted(){
        this.username=storage.get('username');
        this.myHeaders.token=storage.get('token');
        this.userid=storage.get('userid');
        this.requetImgUrl=this.GLOBAL.ImgURL;
        if(this.userid==''){
            this.$router.push({
                  path: '/',
                  query: {
                  }
            }) 
        }
        this.GetZwList();
        this.GetImgList();

      }

     
    }
  </script>
  
  <style  scoped>
    .topheader{
        width: 100%;
        height: 40px;
        background: #3a8ee6;
        display: flex;
    }
    .topheaderleft{
        width: 50%;
        height: 40px;
        padding-left: 20px;
        line-height: 40px;
        box-sizing: border-box;
        text-align: left;
        color: #ffffff;
        font-size: 16px;
    }
    .topheaderright{
        width: 50%;
        height: 40px;
        padding-right: 20px;
        line-height: 40px;
        box-sizing: border-box;
        color: #ffffff;
        font-size: 16px;
        display: flex;
        justify-content: flex-end;
    }
    .back{
        cursor: pointer;
        font-size: 14px;
    }
    .outlogin{
        margin-left: 20px;
        font-size: 14px;
        cursor: pointer;
    }
    .content{
        width: 80%;
        margin: 0 auto;
    }
    .steps{
        width: 100%;
        margin-top: 20px;
    }
    .steps ul{
        width: 100%;
        height: 70px;
        display: flex;
    }
    .steps ul li{
        width: 33.33%;
        height: 70px;
        display: flex;
        flex-wrap: wrap;

    }
    .steptop{
        width: 100%;
        height: 40px;
        display: flex;
    }
    .line{
        width: calc(50% - 20px);
        height: 10px;
        background: #eeeeee;
        margin-top: 15px;
    }
    .stepbottom{
        width: 100%;
        height: 30px;
        line-height: 30px;
        text-align: center;
       
    }

    .stepsicon{
        width: 40px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: #eeeeee;
        display: block;
        border-radius: 30px;
        font-size: 16px;
        font-weight: bold;
        
    }

    .active .steptop .line{
        background: #4EB944;
    } 
    .active .steptop .stepsicon{
        background:#4EB944;
        color: #ffffff;
    }
    .active .stepbottom{
        color: #4EB944;
    }
    .addcontent{
        width: 100%;
    }
    .addtips{
        width: 100%;
        height: 40px;
        margin: 40px 0 20px 0;
        display: flex;
        justify-content: space-between;

    }
    .tipscontent{
        display: flex;
    }
    .addtipsicon{
        width: 20px;
        height: 20px;
        display: block;
        background-size: 100%;
        margin-right: 10px;
    }
    .addtips span{
        font-weight: bold;
    }
    .mxfrom{
        width: 100%;
    }
    .addmxfrom{
        width: 100%;
        display: flex;
        flex-wrap: wrap;
    }
    .el-select /deep/  .el-input__inner{
  padding-right: 15px !important;
  width: auto !important;
}
.el-input--prefix /deep/ .el-input__inner{
  padding-right: 15px !important;
  width: auto !important;
}
/* .el-input--prefix /deep/ .el-input__inner{
padding-left: 15px !important;
} */

.el-input--suffix /deep/ .el-input__inner{
  padding: 0 15px;
}
.el-select /deep/ .el-input__inner{
  padding: 0 15px;
}
.mxtextarea{
    width: 100%;
}
.el-textarea{
    width: calc(100% - 140px);
}
.mxtextarea /deep/ .el-form-item__content{
    margin-left: 0px !important;
}
.el-table /deep/ th{
background:#eeeeee ;
border-color: #dddddd ;
color: #000000;
text-align: center;
}
.el-dropdown-link {
cursor: pointer;
color: #409EFF;
}
.syjdimg{
    display: flex;
    margin: 20px 0;
}
.syjdspan{
    width: 128px;
    padding: 0 12px 0 0;
    display: block;
    text-align: right;
}
.addzwimgsContent{
  width: 100px;
  height: 100px;
  border: 1px dashed #eeeeee;
}
.addzwimgsContent p{
  padding: 0px;
  background: #eeeeee;
  margin: 0px;
  text-align: center;
}
.pxss-save-qx{
    width: 30%;
    margin: 60px auto;
    display: flex;
    justify-content: center;

}
.pxss-save-qx /deep/.el-button--primary{
    color: #fff;
    background-color: #2cabe3;
    border-color: #2cabe3;
}
.syjdimgtarget{
    width: 100px;
    height: 100px;
}
.addzwbtns{
    width: 100%;
    display: flex;
    justify-content: center;
}
.pages{
    text-align: right;
    margin-top: 10px;
}
.nextbtns{
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: center;
    margin: 40px 0;
}
.nextbtn{
    width: 120px;
}
.zwimgs{
    width: 100%;

}
.zwimgsul{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  padding: 0px;
  list-style-type: none;
}
.zwimgsul li{
  width: 60px;
  margin-bottom: 10px;
    margin-right: 10px;
    cursor: pointer;
}
.zwimgs img{
    width: 60px;
    height: 60px;
    border: 1px solid #eeeeee;

}
.zwimgs-span{
  width: 100%;
  display: block;
  text-align: center;
  background: #eeeeee;
}

  </style>
  


// WEBPACK FOOTER //
// src/components/MAKEMODEL/makemodelstepone.vue